import { useNotification } from '@/shared/composables/useNotification';

const notification = useNotification();
const copyMessage = async (content: string) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(content);
        notification.show('Texto copiado com sucesso!');
      } else {
        // Fallback para navegadores que não suportam clipboard API
        const textArea = document.createElement('textarea');
        textArea.value = content;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          const successful = document.execCommand('copy');
          if (successful) {
            notification.show('Texto copiado com sucesso!');
          } else {
            throw new Error('Falha ao copiar texto');
          }
        } catch (err) {
          console.error('Erro ao copiar texto:', err);
          notification.show('Erro ao copiar texto', 'error');
        } finally {
          document.body.removeChild(textArea);
        }
      }
    } catch (err) {
      console.error('Erro ao acessar clipboard:', err);
      notification.show('Erro ao copiar texto', 'error');
    }
  };

  export { copyMessage, notification };